
const get_data_value_from_element = (id)=>{
    try {
        return JSON.parse(document.getElementById(id).getAttribute('data_value'))
    } catch(e){
        return null;
    }
};
export default (type, is_water)=>{
    const color = is_water ? '#49A1CC' : '#FCB33D'
    return {
        labels: get_data_value_from_element(`${type}-labels`),
        datasets: [
            {
                label: "dataset",
                fillColor: "#FFFDFA",
                strokeColor: color,
                pointColor: "#4545454",
                pointStrokeColor: color,
                pointHighlightFill: "#4545454",
                pointHighlightStroke: "rgba(220,220,220,1)",
                data: get_data_value_from_element(`${type}-data`)
            }
        ]
    };
}